<template>
  <div :class="$style.container">
    <div
      v-m-b="10"
      :class="$style.amount"
      v-text="displayAmount"
    ></div>

    <div
      :class="$style.question"
      v-text="$t('tips.payment.question')"
    >
    </div>

    <div
      v-if="tipsList"
      v-m-t="20"
      :class="$style.content"
    >
      <simple-button
        v-for="tip in tipsList"
        :key="tip.id"
        :actived="currentTipId === tip.id"
        :fluid="false"
        v-p-l="16"
        v-p-r="16"
        variant="outlined"
        @click="$emit('change', tip.amount)"
      >
        <strong>{{ tip.percent }}%</strong>
      </simple-button>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

import SimpleButton from 'molecules/common/SimpleButton';

export default {
  name: 'TipsManagement',
  components: {
    SimpleButton,
  },
  props: {
    billAmount: {
      type: [Number, null],
      default: null,
    },
    currency: {
      type: Object,
      required: true,
    },
    tipsAmount: {
      type: [Number, null],
      default: null,
    },
    tipsList: {
      type: Array,
      requried: true,
    },
  },
  data() {
    return {
      currentTipId: null,
    };
  },
  computed: {
    displayAmount() {
      return this.$t('tips.payment.bill.amount', {
        amount: formatAmount(this.billAmount, this.currency),
      });
    },
  },
  watch: {
    tipsAmount: {
      immediate: false,
      handler: 'setPercent',
    },
    tipsList: {
      immediate: true,
      handler: 'setDefaultPercent',
    },
  },
  methods: {
    setDefaultPercent() {
      const tips = this.$validate.isFixedLengthArray(this.tipsList, 1)
        ? this.tipsList[0]
        : this.tipsList[this.tipsList.length - 2];

      this.currentTipId = tips.id;

      this.$emit('change', tips.amount);
    },
    setPercent(amount) {
      const tips = this.tipsList.find(tips => tips.amount === amount);

      if (tips) {
        this.currentTipId = tips.id;
      } else {
        this.currentTipId = null;
      }
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type('regular', 14, 20)
    padding: 20px
    color: #212121
    background-color: #fff
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px

  .amount
    +font-type('semi-bold', 16, 20)
    text-align: center

  .question
    text-align: center

  .content
    display: flex
    flex-direction: row
    justify-content: center
    flex-wrap: wrap
    gap: 10px
</style>
